module.exports = __webpack_public_path__ + "static/img/integate-banner2.1eb8535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/integate-banner2.png
// module id = oTjf
// module chunks = 150